// import React, { useEffect, useMemo, useRef, useState } from "react";
// import {
//   Box,
//   Button,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   Snackbar,
// } from "@mui/material";
// import { useToast } from "../../../../../context/toastContext";
// import { useParams } from "react-router-dom";
// import { useGeneralContext } from "./GeneralContext";
// import { MRT_DefaultColumn } from "material-react-table";

// export function ModelingControls() {
//   const {
//     modelingData,
//     setModelingData,
//     selectedModelingRevision,
//     setSelectedModelingRevision,
//     setGeneralProjectPath,
//     generalProjectPath,
//     setRevision,
//     getRevisionsFromPath,
//   } = useGeneralContext();

//   const { toast } = useToast();
//   const { id } = useParams();

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const handleSnackbarClose = () =>
//     setSnackbar((prev) => ({ ...prev, open: false }));

//   const revisions = useMemo(() => {
//     if (!modelingData || typeof modelingData !== "object") return [];

//     // 1. Filter valid revision keys
//     let revisionKeys = Object.keys(modelingData).filter(
//       (key) => !key.startsWith("__") && !Number.isNaN(Number(key)),
//     );

//     // 2. Ensure "0" exists
//     if (!revisionKeys.includes("0")) {
//       revisionKeys.push("0");
//     }

//     // 3. Sort numerically
//     return revisionKeys.sort((a, b) => Number(a) - Number(b));
//   }, [modelingData]);

//   async function handleSetGeneralProjectPath() {
//     const res = await window.electron.openFolder(1);
//     if (res?.path) {
//       setGeneralProjectPath(res.path);
//       await window.electron.db.setProjectPath(id, res.path);

//       toast("Project folder has been set");

//       await getRevisionsFromPath(res.path);
//     }
//   }

//   // Handle revision change
//   async function handleChangeRevision(e) {
//     const value = e.target.value;
//     let currentRevision = value; // default = selected existing revision

//     if (value === "__new") {
//       const nextRev = String(Math.max(...revisions.map(Number)) + 1);
//       const LastRev = String(Math.max(...revisions.map(Number)));

//       console.log("Creating new revision:", nextRev);

//       // console.log(generalProjectPath, selectedModelingRevision, nextRev);
//       window.electron.freecad.makeRevision(
//         generalProjectPath,
//         LastRev,
//         nextRev,
//       );

//       setModelingData((prev) => ({
//         ...prev,
//         [nextRev]: JSON.parse(JSON.stringify(prev[LastRev] || {})),
//       }));
//       currentRevision = nextRev;
//       setSelectedModelingRevision(nextRev);
//       setRevision(nextRev);
//       console.log(
//         "Modeling Data after creating new revision:",
//         MRT_DefaultColumn,
//       );
//     } else {
//       setSelectedModelingRevision(value);
//       setRevision(value);
//     }

//     window.electron.freecad.openRevision(generalProjectPath, currentRevision);
//   }

//   return (
//     <Box
//       display="flex"
//       alignItems="center"
//       gap={2}
//       justifyContent="center"
//       sx={{
//         display: "flex",
//         p: 0.7,
//       }}
//     >
//       <Box display="flex" alignItems="center" gap={2}>
//         <FormControl size="small">
//           <InputLabel>Revisions</InputLabel>
//           <Select
//             value={selectedModelingRevision}
//             onChange={handleChangeRevision}
//             label="Revision"
//             sx={{ minWidth: 140 }}
//           >
//             {revisions.map((rev, idx) => (
//               <MenuItem value={rev} key={rev} selected={idx === 0}>
//                 {rev}
//               </MenuItem>
//             ))}
//             <MenuItem value="__new" sx={{ fontStyle: "italic", color: "gray" }}>
//               + Add New Revision
//             </MenuItem>
//           </Select>
//         </FormControl>
//       </Box>
//       <Button
//         variant="outlined"
//         disabled={!window.electron?.isElectron}
//         onClick={handleSetGeneralProjectPath}
//       >
//         Set Project Path
//       </Button>
//     </Box>
//   );
// }

import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  Alert,
} from "@mui/material";

import { useParams } from "react-router-dom";

import { useToast } from "../../../../../context/toastContext";
import { useGeneralContext } from "./GeneralContext";

export function ModelingControls() {
  const {
    modelingData,
    setModelingData,
    selectedModelingRevision,
    setSelectedModelingRevision,
    setGeneralProjectPath,
    generalProjectPath,
    setRevision,
    getRevisionsFromPath,
  } = useGeneralContext();

  const { toast } = useToast();
  const { id } = useParams();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSnackbarClose = () =>
    setSnackbar((prev) => ({ ...prev, open: false }));

  const revisions = useMemo(() => {
    if (!modelingData || typeof modelingData !== "object") return [];

    let revisionKeys = Object.keys(modelingData).filter(
      (key) => !key.startsWith("__") && !Number.isNaN(Number(key)),
    );

    if (!revisionKeys.includes("0")) {
      revisionKeys.push("0");
    }

    return revisionKeys.sort((a, b) => Number(a) - Number(b));
  }, [modelingData]);

  async function handleSetGeneralProjectPath() {
    const res = await window.electron.openFolder(1);
    if (res?.path) {
      setGeneralProjectPath(res.path);
      await window.electron.db.setProjectPath(id, res.path);

      toast("Project folder has been set");

      await getRevisionsFromPath(res.path);
    }
  }

  async function handleChangeRevision(e) {
    const value = e.target.value;
    let currentRevision = value;

    if (value === "__new") {
      const nextRev = String(Math.max(...revisions.map(Number)) + 1);
      const lastRev = String(Math.max(...revisions.map(Number)));

      console.log("Creating new revision:", nextRev);

      await window.electron.freecad.makeRevision(
        generalProjectPath,
        lastRev,
        nextRev,
      );

      setModelingData((prev) => ({
        ...prev,
        [nextRev]: JSON.parse(JSON.stringify(prev[lastRev] || {})),
      }));

      currentRevision = nextRev;
      setSelectedModelingRevision(nextRev);
      setRevision(nextRev);
    } else {
      setSelectedModelingRevision(value);
      setRevision(value);
    }

    try {
      console.log("Opening revision");

      const response = await window.electron.freecad.openRevision(
        generalProjectPath,
        currentRevision,
      );

      console.log("openRevision response:", response);

      if (
        response?.code === "200" ||
        Object.keys(response || {}).length === 0
      ) {
        setSnackbar({
          open: true,
          message: `Revision ${currentRevision} opened successfully`,
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: response?.message || "Failed to open revision",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error opening revision:", error);
      setSnackbar({
        open: true,
        message: "Error while opening revision",
        severity: "error",
      });
    }
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      justifyContent="center"
      sx={{
        display: "flex",
        p: 0.7,
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <FormControl size="small">
          <InputLabel>Revisions</InputLabel>
          <Select
            value={selectedModelingRevision}
            onChange={handleChangeRevision}
            label="Revision"
            sx={{ minWidth: 140 }}
          >
            {revisions.map((rev, idx) => (
              <MenuItem value={rev} key={rev} selected={idx === 0}>
                {rev}
              </MenuItem>
            ))}
            <MenuItem value="__new" sx={{ fontStyle: "italic", color: "gray" }}>
              + Add New Revision
            </MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Button
        variant="outlined"
        disabled={!window.electron?.isElectron}
        onClick={handleSetGeneralProjectPath}
      >
        Set Project Path
      </Button>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
